// export const SERVER_IP = "https://nodejsapiengine.uc.r.appspot.com/";
export const SERVER_IP = "https://epcms.pestpro.com.sg:8080/";
// export const SERVER_IP = " http://20.198.225.156:8080/";
export const PrimaryColor = "#f15a29";
export const UpdateModalWidth = 900;
